// Function to dynamically get the backend URL from env
const getBackendURL = () => {
  // Use environment variable first
  if (process.env.REACT_APP_API_BASE) {
    return process.env.REACT_APP_API_BASE;
  }

  // Fallback for development if env is not set
  return `http://${window.location.hostname}:8000/api`;
};

// Exported constant that other modules can import and use
export const baseUrl = getBackendURL();

